<template>
  <header id="top" ref="headerTop" class="fixed-top shadow-sm bg-white">
    <the-impersonate-stop/>

    <div class="header-container">
      <!-- Line 1: Admin & User Bar -->
      <the-admin-header/>

      <!-- Line 2: Brand & Main Menu -->
      <div class="user-header border-top">
        <div class="container-xl">
          <div class="d-flex align-items-center h-100">
            <div class="uq-header-logo-merged d-flex align-items-center pe-4 me-2">
              <a
                id="header-logo"
                class="d-flex align-items-center text-decoration-none"
                style="cursor: pointer;"
                @click.prevent="$router.push(logoRoute)"
              >
                <img
                  :alt="$t('general.shared.appLogoAlt')"
                  src="https://site.waw.travel/images/wawlogo.svg"
                  style="height: 40px; width: auto; min-width: 100px; display: block;"/>
              </a>
            </div>

            <nav class="navbar navbar-expand-lg py-0 flex-grow-1">
              <div class="container-fluid d-flex align-items-center p-0">
                <!-- Mobile Toggler -->
                <button
                  id="btn-header-hamburger"
                  ref="btnHeaderHamburger"
                  aria-controls="navbarToggleExternalContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  class="navbar-toggler hamburger hamburger--slider shadow-none py-0 ms-auto"
                  data-bs-target="#navbarToggleExternalContent"
                  data-bs-toggle="collapse"
                  type="button"
                  @click="openCloseHamburger"
                >
                  <span class="hamburger-box">
                    <v-icon icon="hamburger" size="xxl"/>
                  </span>
                </button>

                <!-- Main Menu -->
                <div
                  id="navbarToggleExternalContent"
                  class="collapse navbar-collapse justify-content-end">
                  <the-menu/>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import TheMenu from '@/components/header/TheMenu.vue';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';
import TheImpersonateStop from '@/components/header/TheImpersonateStop.vue';
import TheAdminHeader from '@/components/header/TheAdminHeader.vue';

export default defineComponent({
  name: 'TheHeader',
  components: {
    TheAdminHeader,
    TheImpersonateStop,
    VIcon,
    TheMenu,
  },
  computed: {
    ...mapState(useAuthStore, ['user', 'agency']),
    logoRoute() {
      if (this.agency?.isCollaborator) {
        return { name: 'collaboratorDashboard' };
      } else {
        return { name: 'case-v2.index' };
      }
    }
  },
  methods: {
    openCloseHamburger() {
      const buttonClose: any = this.$refs.btnHeaderHamburger;
      const main: any = document.getElementById('main');

      if (!!buttonClose) {
        if (!buttonClose.classList.contains('is-active')) {
          buttonClose.classList.add('is-active');

          if (window.innerWidth < 992) {
            main.classList.add('menu-open');
          }
        } else {
          buttonClose.classList.remove('is-active');
          main.classList.remove('menu-open');
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
#top {
  background: white;
}

.uq-header-logo-merged {
  background-color: #ffffff;
}

.user-header {
  min-height: 60px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
}

:deep(.nav-link) {
  padding: 4px 10px !important;
  font-size: 12px !important;
  font-weight: 600;
  text-transform: uppercase;
  color: #2D2D2D;
  transition: all 0.2s ease;
  border-radius: 4px;
  
  &:hover {
    color: #000000;
    background-color: #f8f9fa;
  }
}

:deep(.router-link-active),
:deep(.router-link-exact-active) {
  color: #ffffff !important;
  font-weight: 700 !important;
  background-color: #000000 !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2) !important;
  
  &, * {
    color: #ffffff !important;
  }
}
</style>
